var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgYeswareIconContact = function SvgYeswareIconContact(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 35,
    rx: 8,
    fill: "#ECF6FB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.068 8.782a.5.5 0 0 1 .864 0l2.65 4.548a.5.5 0 0 0 .326.238l5.145 1.114a.5.5 0 0 1 .267.821l-3.508 3.926a.5.5 0 0 0-.124.383l.53 5.238a.5.5 0 0 1-.7.508l-4.816-2.123a.5.5 0 0 0-.404 0l-4.817 2.123a.5.5 0 0 1-.699-.508l.53-5.238a.5.5 0 0 0-.124-.383L8.68 15.503a.5.5 0 0 1 .267-.821l5.145-1.114a.5.5 0 0 0 .326-.238l2.65-4.548Z",
    fill: "#29ABE2"
  })));
};
export default SvgYeswareIconContact;